// extracted by mini-css-extract-plugin
export default {"wrapper":"settings_wrapper__vPcy7","item":"settings_item__ZcIbX","label":"settings_label__-Mp0Q","value":"settings_value__-cEyh"};